import { render, staticRenderFns } from "./InviteProvider.vue?vue&type=template&id=89802158&"
import script from "./InviteProvider.vue?vue&type=script&lang=js&"
export * from "./InviteProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports